// Re-export from new modular structure for backward compatibility
import AddPlayerStatsForm from './P.StatForm/index.jsx';

export default AddPlayerStatsForm;
